import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../icon/icon';
import type { IconName } from '../icon/icon';

export interface BreadcrumbItem {
  label: string;
  link?: string;
  icon?: IconName;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-breadcrumbs',
  imports: [RouterLink, IconComponent],
  styleUrl: './breadcrumbs.scss',
  templateUrl: './breadcrumbs.html',
})
export class BreadcrumbsComponent {
  /** Éléments du fil d'Ariane, du plus général au plus précis. */
  readonly items = input<BreadcrumbItem[]>([]);

  /** Texte accessible pour le bloc de navigation. */
  readonly ariaLabel = input('Fil d’Ariane');

  protected readonly ancestors = computed(() => this.items().slice(0, -1));
  protected readonly current = computed(() => this.items()[this.items().length - 1]);
}
